module.exports = __webpack_public_path__ + "static/media/edek3.70e8ef08.png";